module.exports = __webpack_public_path__ + "fonts/18d5584.woff";